import React from "react";
import styled from "styled-components";
import { AppButton } from "site/ui";
import { ICourse, ILesson, IModule, IUserCourse } from "utils/types";
import { CardBadge } from "common";
import { getThemeColor } from "utils";
import { BsCheck2Circle } from "react-icons/bs";

const Container = styled.div`
  max-width: 1000px;
  padding: 2rem 1.5rem;
  font-family: "Manrope", sans-serif;
`;

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
  font-size: 14px;
  color: #6b7280;

  a {
    color: #5575f7;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Header = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: column;
`;
const CourseImage = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
`;

const HeaderContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 0 0 1rem 0;
`

const Title = styled.div`
  font-size: 40px;
  font-weight: 600;
  color: #111827;
  font-family: "Manrope-Bold";
  line-height: 48px;
`;

const Description = styled.p`
  // font-family: "Manrope-Regular";
  font-weight: 400;
  font-style: ☞;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 22px;
  letter-spacing: 0px;

`;

const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin: 2rem 0 1rem 0;
`;

const SubSectionTitle = styled.h3`
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 20px;
  font-weight: 600;
  color: #5575f7;
  margin: 1.5rem 0 1rem 0;
  cursor: pointer;
`;
const Link = styled.div`
  color: ${getThemeColor("light", "primary")};
  cursor: pointer;
  text-decoration: underline;
`
const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem 0;

  li {
    position: relative;
    padding-left: 1.5rem;
    margin-bottom: 0.75rem;
    font-size: 14px;
    color: #4b5563;
    line-height: 1.6;

    &::before {
      content: "•";
      position: absolute;
      left: 0;
      color: #5575f7;
    }
  }
`;
const ReadCount = styled.div`
  // font-family: "Manrope-Regular";
  font-weight: 400;
  font-style: ☞;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 22px;
  letter-spacing: 0px;
`
export interface CourseStudyIntroProps {
  course?: ICourse;
  modules: IModule[];
  userCourse?: IUserCourse;
  onMoveToCourseStudy: (data: {
    courseId: string; module?: IModule; userCourse?: IUserCourse
  }) => void;
  onBack?: () => void;
  onBackToOverview: () => void;
}
export const CourseStudyIntro: React.FC<CourseStudyIntroProps> = ({
  modules, course, userCourse, onMoveToCourseStudy, onBack, onBackToOverview,
}) => {
  const hasModules = modules?.length > 0
  return (
    <Container>
      <Breadcrumb>
        <Link onClick={onBack}>Home</Link> &gt;
        <Link onClick={onBackToOverview}>Overview</Link> &gt;
        {/* <Link to="/dashboard">Medical exams</Link> &gt; */}
        <span style={{textTransform: "uppercase"}}>{course?.category}</span>
      </Breadcrumb>

      <Header>
        <CourseImage src={course?.image} alt={course?.category} />
        <HeaderContent>
          <TitleContainer>
            <Title>{course?.title}</Title>
            <CardBadge style={{ fontSize: 16 }} $isPremium={course?.courseType === "premium"}>{course?.courseType}</CardBadge>
          </TitleContainer>
          <Description>
            {course?.description}
          </Description>
        </HeaderContent>
      </Header>

      <SectionTitle id="outline">Course outline</SectionTitle>
      <List>
      {modules?.map((item, index) => {
        return (
          <li key={`${item.id}--${index}`}>
            <SubSectionTitle onClick={() => {
              if(course){
                onMoveToCourseStudy({
                  courseId: course.id, 
                  module: item,
                  userCourse
                })
              }
            }} style={{fontSize: 16 }}>
              {item.title} {" "}       
              {userCourse?.completedCourseModuleIds.includes(item.id) && <BsCheck2Circle color="#5575f7" size={24}/>}
            </SubSectionTitle>
            <div dangerouslySetInnerHTML={{__html: item.description || ""}}/>
            {item.lessons && item.lessons?.length > 0 && (
              <List>
                {item.lessons?.map((lesson, index) => {
                  return (
                    <li key={`${lesson.id}--${index}`}>
                      <SubSectionTitle style={{fontSize: 14, color: "#111827" }}>{lesson.title}</SubSectionTitle>
                      {/* <div dangerouslySetInnerHTML={{__html: lesson.description || ""}}/> */}
                    </li>
                  )
                })}
              </List>
            )}
          </li>
        )
      })}
      </List>

       <AppButton variant="primary" disabled={!hasModules} onClick={() => {
          if(course && modules.length > 0){
            onMoveToCourseStudy({
              courseId: course.id,
              module: modules[0],
              userCourse
            })
          }
        }}>
          Start
        </AppButton>
    </Container>
  );
};
